import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { connect } from 'transfer/utils/p2p-connect'
import content from 'pp-react-l10n'
import Overpanel from 'react-components/overpanel'
import CashAdvanceFeesDisclosure from './cashAdvanceFeesDisclosure'
import { toggleCashAdvanceFeesOverpanel } from 'transfer/actions/overpanels'
import { trackCashAdvanceFeesClick } from '../../utils/cash-advance-fees-analytics'

let i18n = content('transfer/inc/cashAdvanceFees')

type Props = {
  isMobile: boolean,
  showCashAdvanceFeesOverpanel: boolean,
  showGenericAboutCashAdvanceFeesOverpanel: boolean,
  currentSelectedFundingOption: Object,
  isGuest: boolean,
  handleClose: () => any,
  handleNext: () => any,
}

export class CashAdvanceFeesOverpanel extends Component<Props> {
  render() {
    const {
      showCashAdvanceFeesOverpanel,
      currentSelectedFundingOption: fundingOption,
      isGuest,
      handleNext,
      handleClose,
    } = this.props

    return (
      /*
       * preset is being set to 'FULL' but its still a center modal because
       * of the overrides.  We don't want the ever expanding grib columns.
       */
      <React.Fragment>
        <Overpanel
          show={showCashAdvanceFeesOverpanel}
          handleClose={() => {
            trackCashAdvanceFeesClick('cancelCashAdvanceFeeWarning')
            handleClose('ACTIONS')
          }}
          a11yTitle={i18n('actionable.title')}
          hideCloseButton={true}
        >
          <DocumentTitle title={i18n('a11y.document.actionable.title')}>
            <CashAdvanceFeesDisclosure
              isGuest={isGuest}
              fundingOption={fundingOption}
              handleNext={handleNext}
            />
          </DocumentTitle>
        </Overpanel>
      </React.Fragment>
    )
  }
}

export default connect(
  ({ overpanels, server }) => ({
    isMobile: server.isMobile,
    showCashAdvanceFeesOverpanel: overpanels.showCashAdvanceFeesOverpanel,
    showGenericAboutCashAdvanceFeesOverpanel:
      overpanels.showGenericAboutCashAdvanceFeesOverpanel,
    cashAdvanceFeesOverpanelContentType:
      overpanels.cashAdvanceFeesOverpanelContentType,
    currentSelectedFundingOption: overpanels.currentSelectedFundingOption,
  }),
  dispatch => ({
    handleClose: type => {
      dispatch(toggleCashAdvanceFeesOverpanel({ show: false, type }))
    },
  })
)(CashAdvanceFeesOverpanel)
